import { get, total as _total, paginate as _paginate } from '@kit/utils/APIV1.js'

export const paginate = async(sortField, cast, direction, page, numberPerPage) => {
  return _paginate('news-clips', sortField, cast, direction, page, numberPerPage)
}
export const total = async() => {
  return _total('news-clips')
}
export const page = async() => {
  return get("news-page")
}
export const newsStory = async(urlSlug) => {
  return get(`news-story/url_slug/${urlSlug}`)
}
 